import { post } from 'src/utils/http'
import SimpleLayout from '../../../../layouts/SimpleLayout'
import { useNavigate, useParams } from 'react-router-dom'
import { useEffect } from 'react'

const OrgSignUpPage = () => {
  let { orgId, code } = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    post(`orgs/${orgId}/sign-up`, {}, { params: { code } })
      .then(() => navigate(`/orgs/${orgId}`))
      .catch(() => navigate('/'))
  }, [orgId, code, navigate])

  return (
    <SimpleLayout className="justify-start"></SimpleLayout>
  )
}

export default OrgSignUpPage
